/**
 * PGSS-5326 — where the Reverse control is allowed to appear.
 *
 * `param.name === 'payment'` is shared by three different dialogs, all opened from
 * OpenOrdersRowAction:
 *
 * - VIEW_PAYMENT          → title "Payment History", carries `type: 'View'`
 * - MAKE_PAYMENT          → title "Add Payment"
 * - MAKE_ADVANCE_PAYMENT  → title "Add Advance Payment", carries `paymentType: 'advance'`
 *
 * Reversing belongs on the history view only. Offering it inside a form for recording a new
 * payment invites the wrong click, and an advance payment is held against the order rather than
 * settled against the invoice, so the invoice reversal does not apply to it.
 *
 * Supplier invoices are excluded as well: the reversal puts customer orders back, and a supplier
 * invoice has none, so it would move the invoice while leaving everything behind it untouched.
 */
export default function isPaymentHistoryView(param) {
  if (!param || param.name !== 'payment') {
    return false;
  }
  return param.type === 'View'
    && param.paymentType !== 'advance'
    && !param.isSupplierInvoice;
}

/**
 * PGSS-5326 — whether THIS row may be reversed.
 *
 * The answer cannot be worked out on the client. The payment list merges two tables, and a payment
 * that has already been returned keeps its original positive row so the ledger shows both halves —
 * so neither the amount nor anything else visible distinguishes it from a returnable one. The
 * server resolves it and says so; the screen only obeys.
 */
export function canReverseRow(row) {
  return row?.reversible === true;
}
